export const CHANGE_ENTITY = 'statistics/CHANGE_ENTITY';

export const CHANGE_STATS = 'statistics/CHANGE_STATS';
